import React from 'react';

interface EyeIconProps {
    width?: number;
    height?: number;
    strokeColor?: string;
    strokeWidth?: number
}

const EyeIcon = ({ width = 52, height = 52, strokeColor = 'black', strokeWidth = 1.5 }: EyeIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M46.6786 23.9308C47.3373 24.8538 47.6666 25.3175 47.6666 26C47.6666 26.6847 47.3373 27.1462 46.6786 28.0692C43.719 32.2205 36.1595 41.1667 26 41.1667C15.8383 41.1667 8.28098 32.2183 5.32131 28.0692C4.66265 27.1462 4.33331 26.6825 4.33331 26C4.33331 25.3153 4.66265 24.8538 5.32131 23.9308C8.28098 19.7795 15.8405 10.8333 26 10.8333C36.1616 10.8333 43.719 19.7817 46.6786 23.9308Z"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M32.5 26C32.5 24.2761 31.8152 22.6228 30.5962 21.4038C29.3772 20.1848 27.7239 19.5 26 19.5C24.2761 19.5 22.6228 20.1848 21.4038 21.4038C20.1848 22.6228 19.5 24.2761 19.5 26C19.5 27.7239 20.1848 29.3772 21.4038 30.5962C22.6228 31.8152 24.2761 32.5 26 32.5C27.7239 32.5 29.3772 31.8152 30.5962 30.5962C31.8152 29.3772 32.5 27.7239 32.5 26Z"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default EyeIcon;
